import { useEffect, useState } from "react";

export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      type="button"
      aria-label="回到顶部"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className="fixed bottom-6 right-4 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-foreground-950 text-background-50 transition-colors duration-200 hover:bg-primary-600 md:right-8"
    >
      <i className="ri-arrow-up-line text-lg"></i>
    </button>
  );
}